module.exports = __webpack_public_path__ + "img/dy.61c05c05.png";